import React, {useContext, useEffect, useState} from 'react';
import {TableColumn, TableSettings} from "../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../common/AbstractListView";
import constants from '../../../constants';
import {Search} from "../../../filtering";

import * as XCol from '../../../framework.core/XExportColumn';

import {
  DateRenderer,
  DateTimeRenderer, FloatRenderer,
  NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextRenderer
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext from '../../common/JobListViewContext';
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import {JobNames} from "../../../framework.core/JobNames";
import {WhInvenDetailListItem} from "../../../fms.data/models/WhInvenDetailListItem";
import {inOutList} from "../tableSettings";
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import Select from '../../../ui/Select';

function StatusFilterRenderer({value, onChange}:any) {
  return (
    <Select
    name='ifms-filter-stat-select'
      value={value}
      onChange={e => onChange(e.target.value)}
      items={[
        { value: 'Received', label: 'Received'},
        { value: 'Pre Receiving', label: 'Pre Receiving'},
        { value: 'Receiving', label: 'Receiving'},
        { value: 'Shipped', label: 'Shipped'},
        { value: 'Pre Shipping', label: 'Pre Shipping'},
        { value: 'Shipping', label: 'Shipping'},
      ]}
    />
  );
}

function ListCommands() {
  return <></>;
}

function ListToolbar() {
  return (
    <>
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
    } else if (unprocessedFkey === "F3") {
    } else if (unprocessedFkey === "F9") {
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F7") {
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F7'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  return (
    <InfoAreaDrawer
      hideMemoList={true}
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.WHInvenDetail}
      jobId={Number((jobListContext.selectedElement as WhInvenDetailListItem|null)?.id) ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

/**
 * Concrete implementation for Other Shipment List screen
 *
 * @class ListView
 * @extends {AbstractListView}
 */
class ListView extends AbstractListView {

  async fetchAndFormatData(api: any, search: Search): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.WHInvenDetail,
      'WhInvenDetailListItem',
      WhInvenDetailListItem.calculateSearchParameters(search, WhInvenDetailListItem.MapSearchFields),
      1,
      search.pageSize,
      );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: WhInvenDetailListItem.formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'status',
        renderer: StatusFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;
  }

  getRowRenderers(): ListRowRenderer[] {
    // return [
    //   {accessor: 'postDate', Cell: DateTimeRenderer},
    //   {accessor: 'centerNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'refNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'fromTo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'itemNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'itemDesc', Cell: TextAlignLeftRenderer},
    //   {accessor: 'location', Cell: TextAlignLeftRenderer},
    //   {accessor: 'poNo', Cell: TextAlignLeftRenderer},
    //   {accessor: 'qty', Cell: FloatRenderer},
    //   {accessor: 'box', Cell: FloatRenderer},
    //   {accessor: 'lbs', Cell: FloatRenderer},
    //   {accessor: 'cft', Cell: FloatRenderer},
    //   {accessor: 'status', Cell: TextRenderer},
    //   {accessor: 'remark', Cell: TextAlignLeftRenderer},
    // ];
    return WhInvenDetailListItem.getExportCollection().map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if(x.dataIndex === "stat") {
        colRenderer.Cell = () => <span></span>
        colRenderer.Header = () => <span></span>;
      }
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.type === XCol.XCellType.Double) {
        if (x.dataIndex === 'qty' || x.dataIndex === 'box')
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={0} />;
        else
          colRenderer.Cell = (props: any) => <FloatRenderer {...props} decimals={2} />;
      }
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'qty', changedValue: (value: any) => { return value['qty'] } });
    colRenderer.push({ accessor: 'box', changedValue: (value: any) => { return value['box'] } });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'u2Date',
      orderByAscending: false,
    };
  }

  getTableSettings(): TableSettings {
    const tsettings =  inOutList;
    const cols = WhInvenDetailListItem.getExportCollection();
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }
  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: WhInvenDetailListItem) {
    return '';
  }

  getListViewTitle() {
    return 'In/Out Activity List';
  };

  hasMemo(): boolean {
    return false;
  }
}

export default ListView;
